function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-area_svg__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.301 14.592l-1.103 1.104.853.853h-3.725l5.102-5.102v2.063l1.56 1.561V2.183C19.989.98 19.01 0 17.807 0H4.879l1.56 1.561h2.142l-5.14 5.141V2.977l.852.854 1.104-1.104L2.7.027 0 2.728 1.104 3.83l.775-.776v12.872c0 1.204.98 2.183 2.183 2.183h12.91l-.774.775 1.103 1.104L20 17.29l-2.699-2.698zm-6.183 1.957H8.935l9.493-9.493V9.24l-7.31 7.31zM3.44 13.242l11.681-11.68h2.203L3.44 15.444v-2.203zM18.428 2.665v2.183l-11.7 11.7H4.543L18.428 2.666zm-7.64-1.104h2.125L3.44 11.034V8.91L10.79 1.56z",
  fill: "#0685FE"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-area_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgIconArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconArea;